import { useState } from 'react'
import { Wallet } from 'ethers'
import { PluginClient } from '@remixproject/plugin'
import { IRemixApi } from '@remixproject/plugin-api'
import { PluginApi } from '@remixproject/plugin-utils'
import { WalletConfigFileContents } from '../types/walletConfig'
import { useUpdateEnvironment } from './useUpdateEnvironment'

export const useWalletConfig = (client: PluginClient<any, Readonly<IRemixApi>> & PluginApi<Readonly<IRemixApi>>) => {
    const [fileContents, setFileContents] = useState<WalletConfigFileContents>({})
    const { handleUpdateEnvironment } = useUpdateEnvironment()

    const loadWallets = async () => {
        try {
            const rootDirectoryContents = await client.fileManager.readdir('')

            if (!Object.keys(rootDirectoryContents).includes('coti_wallet_config.json')) {
                await client.fileManager.writeFile('coti_wallet_config.json', JSON.stringify({}, null, "\t"))
            }

            const contents: WalletConfigFileContents = JSON.parse(
                await client.fileManager.getFile('coti_wallet_config.json')
            )

            const existingWallet = Object.values(contents).find(entry => entry.private_key)
            
            if (existingWallet) {
                handleUpdateEnvironment(
                    existingWallet.public_key,
                    existingWallet.private_key!,
                    existingWallet.user_key
                )
                setFileContents(contents)
                return
            }

            // Create new wallets if none exist
            const updatedContents = await createNewWallets(contents)
            setFileContents(updatedContents)
            
            await client.fileManager.writeFile(
                'coti_wallet_config.json',
                JSON.stringify(updatedContents, null, "\t")
            )
        } catch (err) {
            console.error('Failed to load wallets:', err)
        }
    }

    const createNewWallets = async (contents: WalletConfigFileContents) => {
        const updatedContents = { ...contents }
        
        for (let i = 0; i < 2; i++) {
            const newWallet = Wallet.createRandom()
            
            updatedContents[Object.keys(updatedContents).length] = {
                type: "LOCAL_WALLET",
                network: "TESTNET",
                public_key: newWallet.address,
                private_key: newWallet.privateKey
            }
            
            if (i === 0) {
                handleUpdateEnvironment(newWallet.address, newWallet.privateKey, undefined)
            }
        }

        return updatedContents
    }

    return {
        fileContents,
        loadWallets
    }
} 